import React from 'react';
import Header from "./header/header";
import Footer from "./footer/footer";
import { Outlet } from "react-router-dom";
import { CartProvider } from '../../../context/CartContext';
import { CartDrawer } from '../../ui/elements/CartDrawer';
import CursorFollower from './CursorFollower';
import BottomBar from './header/sub/BottomBar'; // ← Import du BottomBar (ajustez le chemin si nécessaire)
import { Toaster } from 'react-hot-toast';

export const AppLayout: React.FC = () => {
  return (
    <CartProvider>
      <CursorFollower />
      <div className="flex flex-col min-h-screen font-poppins bg-gray-50">
        {/* Header */}
        <Header />

        {/* Main content */}
        <main className="w-full">
          <Outlet />

          <Toaster position="top-right" />

        </main>

        {/* Footer */}
        <Footer />

        {/* BottomBar (uniquement visible sur mobile) */}
        <BottomBar />
      </div>
      <CartDrawer />
    </CartProvider>
  );
};

export default AppLayout;